/**
 * Seleção do dropdown: lista vazia significa "todos" — é o que o dropdown
 * mostra como "Todas as ofertas" e o que a API recebe. `null` é "nenhum", que
 * só se alcança pela linha "todos" e nunca vai para a API.
 */
export type Selection = string[] | null;

/** Marcar todos um a um volta para vazio ("todos"). */
export function collapseSelection(
  selected: string[],
  allValues: string[]
): string[] {
  const unique = Array.from(new Set(selected));

  if (
    allValues.length > 0 &&
    allValues.every((value) => unique.includes(value))
  ) {
    return [];
  }

  return unique;
}

/** Clique na linha "todos": marca tudo, ou desmarca tudo se já estava. */
export function toggleAll(selected: Selection): Selection {
  return selected !== null && selected.length === 0 ? null : [];
}

/**
 * Clique numa linha. Vindo de "todos" (lista vazia), o clique restringe às
 * demais: sai o item clicado, ficam os outros. O último marcado não sai por
 * aqui — desmarcar tudo é pela linha "todos".
 */
export function toggleSelection(
  selected: Selection,
  value: string,
  allValues: string[]
): Selection {
  if (selected === null) {
    return collapseSelection([value], allValues);
  }

  const current = selected.length === 0 ? allValues : selected;

  if (current.includes(value)) {
    if (current.length === 1) {
      return selected;
    }

    return collapseSelection(
      current.filter((item) => item !== value),
      allValues
    );
  }

  return collapseSelection([...current, value], allValues);
}
